import React, { useState } from 'react';
import { DEVICES, DeviceType, useSimulator } from '../../contexts/SimulatorContext';

export const DeviceSimulatorToggle: React.FC = () => {
  const { activeDevice, setActiveDevice } = useSimulator();
  const [isOpen, setIsOpen] = useState(false);

  // Robust admin check for production visibility
  const isAdmin = (() => {
    try {
      const auth = JSON.parse(localStorage.getItem('oko_auth') || '{}');
      return auth?.role === 'admin' || auth?.username === 'admin' || localStorage.getItem('oko_is_admin') === 'true';
    } catch {
      return localStorage.getItem('oko_is_admin') === 'true';
    }
  })();

  if (!isAdmin && process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-[999999] flex flex-col-reverse gap-2 pointer-events-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-12 h-12 bg-slate-800 border-2 border-slate-600 rounded-full flex items-center justify-center shadow-2xl hover:bg-slate-700 transition-colors text-slate-300"
        title="Toggle Device Simulator"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
        </svg>
      </button>

      {isOpen && (
        <div className="bg-slate-900 border border-slate-700 rounded-lg shadow-2xl p-2 flex flex-col gap-1 w-48 mb-2">
          <div className="text-xs text-slate-400 mb-1 px-2 uppercase font-bold tracking-wider">Simulate Device</div>
          {(Object.keys(DEVICES) as DeviceType[]).map(key => {
            const dev = DEVICES[key];
            const isActive = activeDevice === key;
            return (
              <button
                key={key}
                onClick={() => {
                  setActiveDevice(key);
                  setIsOpen(false);
                }}
                className={`text-left px-3 py-2 text-sm rounded ${isActive ? 'bg-indigo-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}
              >
                {dev.name}
              </button>
            )
          })}
        </div>
      )}
    </div>
  );
};

export default DeviceSimulatorToggle;
